import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=0029f9ac&"
import script from "./BackToTop.ts?vue&type=script&lang=ts&"
export * from "./BackToTop.ts?vue&type=script&lang=ts&"
import style0 from "./BackToTop.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports